/*
*   List of Actions with TYPE that should be passed from accreditation.reducer.js to requirements-assessment.reducer.js
 */

export const PREFIX = 'RCO_REQUIREMENTS_ASSESSMENT';

export const TYPES = {
    FETCH_EVIDENCE_ASSESSMENT:          `${PREFIX}_FETCH_EVIDENCE_ASSESSMENT`,
    RESET_AUTOCOMPLETE_REVIEWER:        `${PREFIX}_RESET_AUTOCOMPLETE_REVIEWER`,
    RESET_SELECTED_EVIDENCE_OWNER:      `${PREFIX}_RESET_SELECTED_EVIDENCE_OWNER`,
    RESET_SELECTED_AUDIT_TASK:          `${PREFIX}_RESET_SELECTED_AUDIT_TASK`,
    SET_DOC_REVISION_REQUEST_DETAILS:   `${PREFIX}_SET_DOC_REVISION_REQUEST_DETAILS`,
    SET_IMPROVEMENT_ACTION_DETAILS:     `${PREFIX}_SET_IMPROVEMENT_ACTION_DETAILS`,
    SET_IMPROVEMENT_STEP_DETAILS:       `${PREFIX}_SET_IMPROVEMENT_STEP_DETAILS`,
    SET_IMPROVEMENT_STEP_DIALOG:        `${PREFIX}_SET_IMPROVEMENT_STEP_DIALOG`,
    UPDATE_IMPROVEMENT_STEP:            `${PREFIX}_UPDATE_IMPROVEMENT_STEP`,
    FETCH_AUDITOR_STATUSES:             `${PREFIX}_FETCH_AUDITOR_STATUSES`,
    FETCH_REVIEW_TASKS:                 `${PREFIX}_FETCH_REVIEW_TASKS`,
    FETCH_SITE_LOCATION_DETAILS:        `${PREFIX}_FETCH_SITE_LOCATION_DETAILS`,
    FETCH_HEAD_OFFICE_DETAILS:          `${PREFIX}_FETCH_HEAD_OFFICE_DETAILS`,
    SELECT_EVIDENCE_DETAILS:            `${PREFIX}_SELECT_EVIDENCE_DETAILS`,
    SET_DOCUMENT_FOR_REVISION_REQUEST:  `${PREFIX}_SET_DOCUMENT_FOR_REVISION_REQUEST`,
    SAVE_UPLOADED_DOCUMENT:             `${PREFIX}_SAVE_UPLOADED_DOCUMENT`,
};
